import React from 'react';
import TextInput from 'components/AGForm/Inputs/TextInput/TextInput';
import SearchSelectInput from 'components/AGForm/Inputs/SelectInput/SearchSelectInput';
import { states, stringRepresentationToOption, stringRepresentationToValues } from 'utils/statesSelect';
import AGForm from 'components/AGForm/AGForm';
import Button from 'components/Button/Button';
import useForm from 'hooks/useForm';
import { useVisitorKiosk } from 'contexts/VisitorKioskContext';

type ValidationFormProps = {
    spotId: number;
};

function ValidationForm({ spotId }: ValidationFormProps) {
    const { handleInput, inputs, handleValueChange, resetState } = useForm({ plate: '', state: '' });
    const { loading, addKioskVisitor } = useVisitorKiosk();

    function handleAddVisitorValidation() {
        const stateAndCountry = stringRepresentationToValues(inputs.state);
        if (!stateAndCountry) return;
        const { state, country } = stateAndCountry;

        addKioskVisitor(spotId, { plate: inputs.plate, state, country });
        resetState({ plate: '', state: '' });
    }

    return (
        <div>
            <AGForm style={{ gap: '0.5rem' }}>
                <TextInput
                    name="plate"
                    label=""
                    value={inputs.plate}
                    onChange={handleInput}
                    placeholder="Enter License Plate Number"
                    errors={null}
                />
                <SearchSelectInput
                    label=""
                    placeholder="Enter License Plate State"
                    options={states}
                    errors={null}
                    onSelected={(value) => {
                        handleValueChange('state', value);
                    }}
                    name="state"
                    selected={stringRepresentationToOption(inputs.state)}
                />
                <Button
                    onClick={handleAddVisitorValidation}
                    disabled={loading || !inputs.plate || !inputs.state}
                    style={{ marginTop: '12px' }}
                >
                    Add Plate
                </Button>
            </AGForm>
        </div>
    );
}

export default ValidationForm;
